// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import { validateAppVersion } from '../../../../../utils/versionService';
import getClientConfig from '../../../../../utils/getClientConfig';

// Actions
import { versionUpdateAvailable } from '../../../../../reducers/version/versionActions';

// Constants
import { TIMES } from '../../../../../../common/utils/timeUtil';

const mapDispatchToProps = (dispatch) => ({
    dispatchVersionUpdateAvailable: ({ safe }) => dispatch(versionUpdateAvailable({ safe })),
});

const AppVersionPoll = ({ dispatchVersionUpdateAvailable }) => {
    React.useEffect(() => {
        const clientConfig = getClientConfig();
        const intervalId = setInterval(async () => {
            const versionResult = await validateAppVersion(clientConfig.appVersion);

            if (versionResult && versionResult.upToDate) return;

            clearInterval(intervalId);

            dispatchVersionUpdateAvailable({ safe: versionResult.safe });
        }, TIMES.HOUR / 2);

        return () => clearInterval(intervalId);
    }, []);

    return null;
};

AppVersionPoll.propTypes = {
    dispatchVersionUpdateAvailable: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(AppVersionPoll);
